const logoUrl = "https://customer-assets-cm19k8pv.emergentagent.net/"
  + "job_skillexpress-lms/artifacts/yfgn6982_1001832063.jpg";

export default function BrandLogo({ testId, variant = "default" }) {
  return (
    <img
      className={`brand-logo brand-logo-${variant}`}
      src={logoUrl}
      alt="Skillexpress"
      data-testid={testId}
    />
  );
}